import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mfa-setup"
export default class extends Controller {
  static targets = ["methodRadio", "submitButton"]

  connect() {
    this.updateSubmitButton()
  }

  methodSelected() {
    this.updateSubmitButton()
  }

  updateSubmitButton() {
    const selectedMethod = this.methodRadioTargets.find(radio => radio.checked)
    
    if (selectedMethod) {
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.classList.remove("opacity-50", "cursor-not-allowed")
      this.submitButtonTarget.classList.add("hover:bg-indigo-700")
      
      // Update form action based on selected method
      const form = this.element.querySelector('form')
      if (selectedMethod.value === 'email') {
        form.action = '/mfa/email_setup'
      } else if (selectedMethod.value === 'totp') {
        form.action = '/mfa/totp_setup'
      }
    } else {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add("opacity-50", "cursor-not-allowed")
      this.submitButtonTarget.classList.remove("hover:bg-indigo-700")
    }
  }
}
